import { awsConfiguration } from '@/aws-configuration';
import { Module, Mutation, VuexModule } from 'vuex-module-decorators';

@Module({ name: 'global' })
export default class GlobalStore extends VuexModule {
  packageVersion = process.env.VUE_APP_VERSION;
  accountId = '';

  defaultCenterLocation = { lat: 48.759586060603674, lng: 3.993354009673202 };

  @Mutation
  updateAccountId(id: string) {
    this.accountId = id;
  }

  @Mutation
  updateCenterLocation(value: any) {
    this.defaultCenterLocation = value;
  }

  get version(): string | undefined {
    return this.packageVersion;
  }

  get defaultMapLocation(): any {
    return this.defaultCenterLocation;
  }
  get gpsTopic(): string {
    return `${awsConfiguration.apiVersion}/${this.accountId}/+/GPSUpdate`;
  }
  get machineMarkerTopic(): string {
    return `${awsConfiguration.apiVersion}/${this.accountId}/+/MachineMarkerStatus`;
  }
  get alarmStatusTopic(): string {
    return `${awsConfiguration.apiVersion}/${this.accountId}/+/AlarmStatusSummary`;
  }
  get filteredMachineMarkerTopic(): string {
    return `${awsConfiguration.apiVersion}/${this.accountId}/+/FilteredMachineMarker`;
  }
  get missionStatusTopic(): string {
    return `${awsConfiguration.apiVersion}/${this.accountId}/+/MissionStatusAutoTransition`;
  }
  get generalNotificationTopic(): string {
    return `${awsConfiguration.apiVersion}/${this.accountId}/GenericNotificationMessage`;
  }
  get machineRasterTopic(): string {
    return `${awsConfiguration.apiVersion}/${this.accountId}/+/MachineRasterMessage`;
  }
  get softwareUpdateTopic(): string {
    return `${awsConfiguration.apiVersion}/${this.accountId}/+/machine_software_update`;
  }
  get UiUpdateTopic(): string {
    return `${awsConfiguration.apiVersion}/${this.accountId}/+/ui_software_update`;
  }
}
